import '../sass/text-and-media.scss';

(() => {
    const $blocks = document.querySelectorAll('.text-and-media');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $readMoreContent = $block.querySelector('.text-and-media__read-more-content');
        const $readMoreOpen = $block.querySelector('.text-and-media__read-more-open');
        const $readMoreOpenBtn = $block.querySelector('.text-and-media__read-more-open-btn');
        const $readMoreCloseBtn = $block.querySelector('.text-and-media__read-more-close-btn');

        const initReadMore = () => {
            if (!$readMoreContent) return;

            const readMoreContentExpandable = new Expandable($readMoreContent);
            const readMoreOpenExpandable = new Expandable($readMoreOpen);

            $readMoreOpenBtn?.addEventListener('click', () => {
                readMoreContentExpandable.open();
                readMoreOpenExpandable.close();
            });

            $readMoreCloseBtn?.addEventListener('click', () => {
                readMoreContentExpandable.close();
                readMoreOpenExpandable.open();
            });
        };

        initReadMore();
    });
})();
